export function removeExtension(filename: string): string {
  return filename.substring(0, filename.lastIndexOf('.')) || filename;
}

export function getFileExtension(filename: string): string | undefined {
  const cleanFileName = filename.split(/[?#]/)[0];
  if (!cleanFileName.includes('.')) return undefined;
  return cleanFileName.split('.').pop()?.toLowerCase();
}
export function addExtension(path: string, extension: string): string {
  const ext = extension.startsWith('.') ? extension : `.${extension}`;
  return `${path}${ext}`;
}
